import React from "react";

const Videos = props => (
  <svg width="28" height="24" {...props}>
    <g fill="none" fillRule="evenodd">
      <g>
        <rect width="18" height="12" fill="#2A7CB5" rx="2" />
        <path
          fill="#FFF"
          d="M12.08 6.47L6.16 8.53a.5.5 0 0 1-.66-.47V3.94a.5.5 0 0 1 .66-.47l5.92 2.06a.5.5 0 0 1 0 .94z"
        />
      </g>
      <g transform="translate(0 13)">
        <rect width="18" height="11" fill="#2A7CB5" rx="2" />
        <path
          fill="#FFF"
          d="M11.82 5.97L6.68 7.94A.5.5 0 0 1 6 7.47V3.53a.5.5 0 0 1 .68-.47l5.14 1.97a.5.5 0 0 1 0 .94z"
        />
      </g>
      <g transform="translate(9 4)">
        <rect
          width="18"
          height="13"
          x=".5"
          y=".5"
          fill="#2A7CB5"
          stroke="#FAFAFA"
          rx="2"
        />
        <path
          fill="#FFF"
          d="M12.15 7.46l-4.96 2A.5.5 0 0 1 6.5 9V5a.5.5 0 0 1 .69-.47l4.96 2a.5.5 0 0 1 0 .93z"
        />
      </g>
    </g>
  </svg>
);

export default Videos;
